import React from 'react';
import styles from './index.css';
const { LazyImg } = require('@ifeng/ui_pc_lazyLoad');
class FourNavPic extends React.PureComponent {
    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const loadImgUrl = 'data:image/svg+xml;utf8,<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="84" height="84"><rect x="0" y="0" width="349" height="196" fill="%23f2f2f2" /></svg>';
        const fourPicItem = content.map((item, index) => (React.createElement("li", { className: styles.fourPicItem, key: index },
            React.createElement("a", { href: item.url },
                React.createElement(LazyImg, { placeholder: loadImgUrl, src: item.image, className: styles.fourPicItemImg, loadData: "load success!!" }),
                React.createElement("h2", { className: styles.fourPicItemTit }, item.title)))));
        return (React.createElement("section", { className: styles.fourNavPic },
            React.createElement("ul", { className: styles.fourPicBox }, fourPicItem)));
    }
}
export default FourNavPic;
